var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("section", { attrs: { id: "faq_main" } }, [
                  _c("h2", [_vm._v("よくある質問")]),
                  _vm._v(" "),
                  _c("div", [
                    _c("h3", [_vm._v("商品に関すること")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "faq_list" }, [
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenItem,
                              Q_close: !_vm.isOpenItem
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenItem()
                              }
                            }
                          },
                          [
                            _vm._m(0),
                            _vm._v(
                              "\n                  商品仕様について\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenItem,
                                expression: "isOpenItem"
                              }
                            ]
                          },
                          [_vm._m(1)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenDelivery,
                              Q_close: !_vm.isOpenDelivery
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenDelivery()
                              }
                            }
                          },
                          [
                            _vm._m(2),
                            _vm._v("商品のお届けについて\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenDelivery,
                                expression: "isOpenDelivery"
                              }
                            ]
                          },
                          [_vm._m(3)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenDeliImposible,
                              Q_close: !_vm.isOpenDeliImposible
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenDeliImposible()
                              }
                            }
                          },
                          [
                            _vm._m(4),
                            _vm._v(
                              "\n                  納品に調整が必要な地域について\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenDeliImposible,
                                expression: "isOpenDeliImposible"
                              }
                            ]
                          },
                          [
                            _c(
                              "p",
                              [
                                _vm._v(
                                  "\n                    恐れ入りますが、下記地域への納品は別途調整させていただきます。"
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "router-link",
                                  { attrs: { to: "/support/input" } },
                                  [_vm._v("お問合わせフォーム")]
                                ),
                                _vm._v(
                                  "よりご希望の商品と納品先のご住所をご連絡ください。\n                    配送不可地域：北海道全域、沖縄全域、四国一部地域、離島など一部地域\n                  "
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenGuarantee,
                              Q_close: !_vm.isOpenGuarantee
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenGuarantee()
                              }
                            }
                          },
                          [
                            _vm._m(5),
                            _vm._v("商品の保証について\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenGuarantee,
                                expression: "isOpenGuarantee"
                              }
                            ]
                          },
                          [_vm._m(6)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenOrderCancel,
                              Q_close: !_vm.isOpenOrderCancel
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenOrderCancel()
                              }
                            }
                          },
                          [
                            _vm._m(7),
                            _vm._v(
                              "注文をキャンセルしたい・商品を返品したい\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenOrderCancel,
                                expression: "isOpenOrderCancel"
                              }
                            ]
                          },
                          [_vm._m(8)]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("h3", [_vm._v("組立設置に関すること")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "faq_list" }, [
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenSetting,
                              Q_close: !_vm.isOpenSetting
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenSetting()
                              }
                            }
                          },
                          [
                            _vm._m(9),
                            _vm._v("設置方法について\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenSetting,
                                expression: "isOpenSetting"
                              }
                            ]
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "各シリーズの商品ページから設置説明書をダウンロードし、設置説明書に従って正しく取り付けて下さい。"
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenService,
                              Q_close: !_vm.isOpenService
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenService()
                              }
                            }
                          },
                          [
                            _vm._m(10),
                            _vm._v("組立設置サービスについて\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenService,
                                expression: "isOpenService"
                              }
                            ]
                          },
                          [_vm._m(11)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenConstructPrice,
                              Q_close: !_vm.isOpenConstructPrice
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenConstructPrice()
                              }
                            }
                          },
                          [
                            _vm._m(12),
                            _vm._v("組立設置料金について\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenConstructPrice,
                                expression: "isOpenConstructPrice"
                              }
                            ]
                          },
                          [_vm._m(13)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenConstructDate,
                              Q_close: !_vm.isOpenConstructDate
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenConstructDate()
                              }
                            }
                          },
                          [
                            _vm._m(14),
                            _vm._v("組立設置作業日について\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenConstructDate,
                                expression: "isOpenConstructDate"
                              }
                            ]
                          },
                          [_vm._m(15)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenConstructTime,
                              Q_close: !_vm.isOpenConstructTime
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenConstructTime()
                              }
                            }
                          },
                          [
                            _vm._m(16),
                            _vm._v(
                              "組立設置(訪問)の時間について\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenConstructTime,
                                expression: "isOpenConstructTime"
                              }
                            ]
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "訪問当日に、具体的な訪問時間をご連絡します。"
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenPrecaution,
                              Q_close: !_vm.isOpenPrecaution
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenPrecaution()
                              }
                            }
                          },
                          [
                            _vm._m(17),
                            _vm._v(
                              "組立設置の注意事項/お願い\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenPrecaution,
                                expression: "isOpenPrecaution"
                              }
                            ]
                          },
                          [_vm._m(18)]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenConsrtuctCancel,
                              Q_close: !_vm.isOpenConsrtuctCancel
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenConsrtuctCancel()
                              }
                            }
                          },
                          [
                            _vm._m(19),
                            _vm._v(
                              "組立設置のキャンセルについて\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenConsrtuctCancel,
                                expression: "isOpenConsrtuctCancel"
                              }
                            ]
                          },
                          [_vm._m(20)]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("h3", [_vm._v("mm/styleの操作に関すること")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "faq_list" }, [
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenUserUpdate,
                              Q_close: !_vm.isOpenUserUpdate
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenUserUpdate()
                              }
                            }
                          },
                          [
                            _vm._m(21),
                            _vm._v("会員情報を変更したい\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenUserUpdate,
                                expression: "isOpenUserUpdate"
                              }
                            ]
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "登録情報確認ページより編集することができます。"
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenOther,
                              Q_close: !_vm.isOpenOther
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenOther()
                              }
                            }
                          },
                          [
                            _vm._m(22),
                            _vm._v("そのほかのお問い合わせ\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenOther,
                                expression: "isOpenOther"
                              }
                            ]
                          },
                          [
                            _c(
                              "p",
                              [
                                _vm._v("ご不明なことがございましたら、"),
                                _c(
                                  "router-link",
                                  { attrs: { to: "/support/input" } },
                                  [_vm._v("お問合わせフォーム")]
                                ),
                                _vm._v("よりご連絡ください。")
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenPayment,
                              Q_close: !_vm.isOpenPayment
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenPayment()
                              }
                            }
                          },
                          [
                            _vm._m(23),
                            _vm._v("購入の流れ・決済について\n                ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenPayment,
                                expression: "isOpenPayment"
                              }
                            ]
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "\n                    お支払い方法は複数あります。"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                    ご注文が完了したあとはお支払い方法の変更はできません。"
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n                    ※ 個人のお客様がご利用いただける支払い方法は「クレジットカード」、「銀行振込」となります。"
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _vm.isCorpLogin
                                ? _c("span", [
                                    _vm._v("※ 法人のお客様は、「"),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "link",
                                        on: { click: _vm.deferPayment }
                                      },
                                      [_vm._v("後払いサービス")]
                                    ),
                                    _vm._v(
                                      "」をご利用いただけます。 ＊申込みと審査が必要となります。"
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "h3",
                          {
                            class: {
                              Q_open: _vm.isOpenWithDrawl,
                              Q_close: !_vm.isOpenWithDrawl
                            },
                            on: {
                              click: function($event) {
                                _vm.selectOpenWithDrawl()
                              }
                            }
                          },
                          [_vm._m(24), _vm._v("退会したい\n                ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isOpenWithDrawl,
                                expression: "isOpenWithDrawl"
                              }
                            ]
                          },
                          [
                            _c("p", [
                              _vm._v("お問い合わせフォームよりご連絡ください。")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      false
                        ? _c("li", [
                            _c(
                              "h3",
                              {
                                class: {
                                  Q_open: _vm.isReceipt,
                                  Q_close: !_vm.isReceipt
                                },
                                on: {
                                  click: function($event) {
                                    _vm.selectReceipt()
                                  }
                                }
                              },
                              [
                                _vm._m(25),
                                _vm._v("領収書について\n                ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isReceipt,
                                    expression: "isReceipt"
                                  }
                                ]
                              },
                              [_vm._m(26)]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      false
                        ? _c("li", [
                            _c(
                              "h3",
                              {
                                class: {
                                  Q_open: _vm.isPaymentDelivery,
                                  Q_close: !_vm.isPaymentDelivery
                                },
                                on: {
                                  click: function($event) {
                                    _vm.selectPaymentDelivery()
                                  }
                                }
                              },
                              [
                                _vm._m(27),
                                _vm._v(
                                  "お支払い・送料について\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isPaymentDelivery,
                                    expression: "isPaymentDelivery"
                                  }
                                ]
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "→決済手段、送料は商品カスタマイズ画面で仕様に応じて算出される仕組み"
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    商品の仕様は商品ページに記載されております。お確かめ下さい。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    掲載していない仕様に関しましても、ご相談承ります。 お問合わせフォームより各メーカーへご連絡ください。\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    商品の製作にお日にちをいただいております。"
      ),
      _c("br"),
      _vm._v("\n                    工場出荷目安は以下の通りです。"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n                    ・吊戸棚（フロート収納）：10営業日～"),
      _c("br"),
      _vm._v("\n                    ・食器棚（カップボード）：16営業日"),
      _c("br"),
      _vm._v("\n                    ・玄関収納：11営業日"),
      _c("br"),
      _vm._v("\n                    ・棚板：10営業日"),
      _c("br"),
      _vm._v("\n                    ・カウンター下収納：10営業日"),
      _c("br"),
      _vm._v("\n                    ・カウンター：15営業日"),
      _c("br"),
      _vm._v("\n                    ・サイドボード：11営業日～"),
      _c("br"),
      _vm._v("\n                    ・テレビボード：11営業日"),
      _c("br"),
      _vm._v(
        "\n                    ※詳細なお届け日の日程はカートに追加後、購入画面より選択ください。\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    保証期間 対象製品の保証期間は、貴社のご指定場所に納入後1年間とします。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    保証内容 保証期間内に、通常使用範囲で発生した故障については無償で代替品との交換または修理をさせていただきます。 尚、取付設置時の不具合によって生じた破損につきましては、弊社では一切の責任を負いかねます。 保証期間内でも次の場合には原則「有料」にさせていただきます。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    ・使用 上の故意・過失または不当な修理や改造による故障及び損傷"
      ),
      _c("br"),
      _vm._v("\n                    ・消耗部品の取替え や修理"),
      _c("br"),
      _vm._v(
        "\n                    ・お買い上げ後の取付場所の移設、輸送、落下等による故障及び損傷"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・火災 、地震、 水害、落雷、その他天災地変及び公害、塩害、ガス害（硫化ガス等）等による故障及び損傷"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・車両、船舶等に搭載された場合に 生ずる故障及び損傷"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・仕上げの傷等で、お引き渡し時に申し出がなかったもの"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・瑕疵によら ない自然の磨耗、さび、かび、変 質、変色、その他類似の事由による場合"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・維持管理の不備による水漏れ、膨れ、汚れ、さび、給水管、排水管の詰まり 等の不具合"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・第三者による管理上、メンテナンス上等の不備に起因する不具合"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・犬・猫・鳥・鼠等の小動物や虫等の行為に起因する故障及び損傷"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・組立設置説明書に 記載された方法以外の設置内容に起因する損傷や 故障"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・建築躯体の変形等対象商品本体以外の不具合に起因する故障及び損傷"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・異常電圧や指定外の燃料 ・電源（電圧・周波数）の使用及び異常水質による故障及び損傷"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・契約時、 実用化されていた技術では予防することが不可能な現象またはこれが原因で生じ た事故による場合"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・保証期間経過後に申し出があったもの、または保証該当事項の発生後、速やか に申し出がなかったもの"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・一般家庭用 以外（事務所、店鋪、病院等業務用 ）に 使用された場合の故障及び損傷"
      ),
      _c("br"),
      _vm._v("\n                    ・本書のご提示がない場合"),
      _c("br"),
      _vm._v("\n                    ・家具本体にかか わるシーリング処理"),
      _c("br"),
      _vm._v("\n                    ・展示品を転売された場合"),
      _c("br"),
      _vm._v(
        "\n                    ・保証書にお引き渡し年月日、お客様名、販売店名の記入のない場合（領収書等で左記内容がわかる場合はその限り ではありません）、 あるいは字句を書き替えられた場合"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・離島または離島 に準じる遠隔地 へ出張修理を行う場合の出張 に要する実費"
      ),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    オーダー品となる為、購入後の商品のキャンセルは承っておりません。"
      ),
      _c("br"),
      _vm._v(
        "\n                    お届けした商品が注文した商品と異なる場合は、お問合わせフォームよりご報告ください。\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    ご購入いただいた家具の組立・設置を、組立専門業者が行うサービスです。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n                    ■サービスの流れ"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    ①ご注文の際に、組み立て作業の有無を選択いただき、作業希望日を入れていただきます。"
      ),
      _c("br"),
      _vm._v(
        "\n                    (作業希望日は、商品到着予定の3日以降よりご指定ください)"
      ),
      _c("br"),
      _vm._v(
        "\n                    ②ご注文完了後、組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。"
      ),
      _c("br"),
      _vm._v(
        "\n                    ③ご指定の場所にお伺いし、組立作業をいたします。"
      ),
      _c("br"),
      _vm._v(
        "\n                    ④作業後は周辺を清掃し、梱包材を回収します。"
      ),
      _c("br"),
      _vm._v(
        "\n                    ⑤作業終了後、ご確認&検収サインをいただきます。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n                    ■組立指定業者：キャンディルグループ"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n                    （㈱キャンディルテクト、㈱バーンリペア)"),
      _c("br"),
      _vm._v("\n                    URL：https://www.candeal.co.jp/"),
      _c("br"),
      _vm._v(
        "\n                    キャンディルグループでは、大手北欧家具メーカーや、国内有名メーカーなどの家具組み立てを行っております。"
      ),
      _c("br"),
      _vm._v(
        "\n                    経験・知識が豊富なスペシャリストが対応しますので、スピーディーな作業が可能です。安心してお任せください。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    ■家具組立設置サービス詳細に関するお問い合わせ"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n                    ・メール … mmstyle.te@candeal.co.jp"),
      _c("br"),
      _vm._v(
        "\n                    ・お電話 … 03-5625-3095(9:00～18:00)\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    ご購入いただいた家具に応じて組立設置料金が反映されます。"
      ),
      _c("br"),
      _vm._v(
        "\n                    (組立設置オプションには、以下の費用が発生します。"
      ),
      _c("br"),
      _vm._v(
        "\n                    組立技術料：組立作業費および副資材、簡易養生材など"
      ),
      _c("br"),
      _vm._v(
        "\n                    諸経費：交通費(エリアにより異なる)、燃料代など)\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    ご注文の際に、組立設置の作業希望日をお知らせいただきます。(第3希望まで)"
      ),
      _c("br"),
      _vm._v(
        "\n                    ※作業希望日は、商品到着予定の、3日以降よりご指定ください。"
      ),
      _c("br"),
      _vm._v(
        "\n                    組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n                    ■訪問日前までに"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    ・作業スタッフが組み立てにお伺いする前に、お客様にて破損・不良がないかご確認をお願いいたします。"
      ),
      _c("br"),
      _vm._v("\n                    ・スペースの確保をお願いいたします。"),
      _c("br"),
      _vm._v(
        "\n                    ※作業を行うスペースの確保が難しい場合、予めご申告お願いいたします。"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・家具を設置スペースに運んでいただけますと幸いです"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n                    ■作業当日"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    ・作業開始前と終了時に、作業における確認をお願いしております。ご協力のほどよろしくお願いいたします。"
      ),
      _c("br"),
      _vm._v(
        "\n                    ・作業により、電源をお借りする場合があります。あらかじめご了承ください。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    ■その他の注意事項に関しては、利用規約をご確認ください\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    ・ご注文後のキャンセルは、お受けいたしかねます。"
      ),
      _c("br"),
      _vm._v("\n                    (返金いたしかねますので、ご了承ください)"),
      _c("br"),
      _vm._v(
        "\n                    ※なお、日程変更は、なるべく作業予定日の3日前までにお電話にてご連絡ください。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n                    ■家具組立設置サービス詳細に関するお問い合わせ"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n                    キャンディルグループ"),
      _c("br"),
      _vm._v("\n                    メール … mmstyle.te@candeal.co.jp"),
      _c("br"),
      _vm._v(
        "\n                    お電話 … 03-5625-3095 (9:00～18:00)\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n                    →問い合わせフォームから依頼"),
      _c("br"),
      _vm._v("\n                    ・お支払い・送料について"),
      _c("br"),
      _vm._v(
        "\n                    →決済手段、送料は商品カスタマイズ画面で仕様に応じて算出される仕組み\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq_btn" }, [
      _c("span", { staticClass: "css-cancel3" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7702ca48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7702ca48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcFaq.vue
// module id = null
// module chunks = 